import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

import AppLayout from '@/components/layout/AppLayout';

export default function AdminRoute() {
  const { isSalesManager, isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!isSalesManager) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}
